import { HeroVisual } from '../components/HeroVisual'
import { Logo } from '../components/Logo'
import { SiteFooter } from '../components/SiteFooter'
import { SubscribeForm } from '../components/SubscribeForm'
import { TrackChips } from '../components/TrackChips'
import { ROUTE_META } from '../lib/site'
import { useDocumentTitle } from '../lib/useDocumentTitle'
import s from './Landing.module.css'

export function Landing() {
  const meta = ROUTE_META['/']
  useDocumentTitle(meta.title, meta.description)

  return (
    <div className={s.page}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <header className={s.nav}>
        <Logo />
        <span className={s.pill}>
          <span className={s.dot} aria-hidden="true" />
          <span>Launching 2026</span>
        </span>
      </header>

      <main id="main" className={s.hero}>
        <p className={s.eyebrow}>Early access is open</p>

        <h1 className={s.h1}>
          RUN THE
          <br />
          NURSERY
          <br />
          LIKE A <span className={s.accent}>BOSS.</span>
        </h1>

        <p className={s.lead}>
          <span className={s.wide}>
            Feeds, sleep, diapers, and more: by voice or two taps, synced with everyone who
            helps. Tiny Boss keeps it simple for busy parents.
          </span>
          <span className={s.narrow}>
            Feeds, sleep, diapers, and more: by voice or two taps, synced with everyone who
            helps. Tiny Boss keeps it simple for busy parents.
          </span>
        </p>

        <div className={s.visual}>
          <HeroVisual />
        </div>

        <div>
          <SubscribeForm />
        </div>

        <TrackChips />
      </main>

      <SiteFooter />
    </div>
  )
}
